import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "floating-delete-cell h-full pointer-events-auto flex items-center justify-end" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "pl-6 h-[46px]" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "uil uil-trash text-[20px] text-Text/text_high !mr-0" }, null, -1)

import { IncrediButton } from 'incredi-ui';

export default /*#__PURE__*/_defineComponent({
  __name: 'floatingDeleteCell',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_unref(IncrediButton), {
      design: "ghost-grey",
      fab: "",
      class: "flex w-[32px] h-[32px] mr-3 items-center justify-center transition-all !duration-[200ms] floating-edit-cell--button",
      size: "small"
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    })
  ]))
}
}

})